<template>
  <div class="stats-item">
    <div
      v-if="tooltipKey !== 'default'"
    >
      <img
        class="question-mark"
        :src="getImage('question-icon.svg')"
        alt=""
        @click="openPopup"
      >
      <span class="label" v-text="label"></span>
    </div>
    <span v-else class="label" v-text="label"></span>
    <span class="value" :class="{'alert-danger alert text-danger': hasWarning}">
      {{ value }}
      <span class="unit" v-text="unit"></span>
      <img class="warning"
           :id="'warning_' + label"
           :src="getImage('warning-sign.svg')"
           v-if="hasWarning"
           @mouseenter="hover = true"
           @mouseleave="hover = false"
      />
    </span>
    <b-tooltip v-if="hover" :show.sync="hover" :target="'warning_' + label" placement="top" variant="info" boundary="window">
      <span v-if="hasWarning && warning !== null">{{ warning }}</span>
    </b-tooltip>
  </div>
</template>

<script>
import tooltipMixin from '@/mixins/tooltipMixin';
import { mapGetters } from 'vuex';
import { compareValues } from '@/helpers/motorCalculations';

export default {
  name: 'StatsItem',

  mixins: [tooltipMixin],

  data() {
    return {
      hover: false,
    }
  },

  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Number | String,
      required: true,
    },
    unit: {
      type: String,
      required: true,
    },
    hasWarning: {
      type: Boolean,
      default: false,
    },
    warning: {
      type: String,
      default: null,
    }
  },

  methods: {
    openPopup() {
      this.$store.commit('tooltips/setCurrentActive', this.toolTip);
    },
  },

  computed: {
    ...mapGetters({
      tooltips: 'tooltips/getAll',
    }),
  },
};
</script>

<style scoped lang="scss">

.stats-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  margin-top: 8px;

  .question-mark {
    padding-right: 12px;
    transition: all ease 0.2s;
    cursor: pointer;

    &:hover {
      transform: scale(1.1);
    }
  }

  .value {
    color: #3DB0C7;
    display: flex;
    align-items: center;
    transition: all ease 0.2s;

    .unit {
      padding-left: 4px;
    }

    &.alert-danger {
      padding: 0 2px;
      margin: 0;
    }

    .warning {
      width: 20px;
      height: 20px;
      margin-left: 4px;
      transition: inherit;
      cursor: pointer;

      &:hover {
        transform: scale(1.1);
      }
    }
  }
}

</style>